module.exports = __webpack_public_path__ + "packs/media/images/Slider_1-acf712f83cc3981e915047fcc2aa280d.jpg";